@if (text(); as text) {
  <!-- Interpolate, don't innerHTML: values may be user-controlled. -->
  <span>{{ text }}</span>
}
